(function() {
    'use strict';
    angular
        .module('wamasysApp')
        .factory('CommunicationAutomationConf', CommunicationAutomationConf);

    CommunicationAutomationConf.$inject = ['$resource','DateUtils'];

    function CommunicationAutomationConf ($resource,DateUtils) {
        var resourceUrl =  'api/communication-automation-conf/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'queryInclDeleted': {
                method: 'GET',
                isArray: true,
                params: {inclDeleted:true}
            },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    data.frequencePeriodNextDate = DateUtils.convertLocalDateFromServer(data.frequencePeriodNextDate);
                    data.lastExecutionDate = DateUtils.convertLocalDateFromServer(data.lastExecutionDate);
                    return data;
                }
            },
            'getChannel': {
            	url:'api/channel',
                method: 'GET',
                isArray: true
            },
            'preview': {
                url: 'api/communication-automation-conf/preview',
                method: 'POST'
            },
            'chatAssistant': {
                url: 'api/communication-automation-conf/assistant/chat',
                method: 'POST',
                transformRequest: function(data) {
                    return angular.toJson(data);
                }
            },
            'getAssistantUsage': {
                url: 'api/communication-automation-conf/assistant/usage',
                method: 'GET'
            },
            'submitAssistantFeedback': {
                url: 'api/communication-automation-conf/assistant/feedback',
                method: 'POST',
                transformRequest: function(data) {
                    return angular.toJson(data);
                }
            },
            'update': { method:'PUT' ,
                transformRequest: function (data) {
                	var clonedData = Object.assign({}, data);
                	clonedData.frequencePeriodNextDate = DateUtils.convertLocalDateToServer(data.frequencePeriodNextDate);
                	clonedData.lastExecutionDate = DateUtils.convertLocalDateToServer(data.lastExecutionDate);
                    return angular.toJson(clonedData);
                } }
        });
    }
})();
